import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Bpmn } from '@shared/interfaces/bpmn';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BpmnService } from '../services/bpmn.service';

export const bpmnResolverFn = (
	route: ActivatedRouteSnapshot
): Observable<Bpmn> => {
	const bpmnSvc = inject(BpmnService);
	const bpmnId = route.paramMap.get('bpmnId');

	return bpmnId
		? bpmnSvc.find(bpmnId).pipe(catchError(() => of(null)))
		: of(null);
};
